<div class="invitation-rejected text-center">
    <div class="invitation-rejected__illu align-center">
        <img src="assets/images/partner/partner_remove.svg"
             [alt]="'Invitation refusee' | transloco" />
    </div>
    <div class="invitation-rejected__content">
        <div class="invitation-rejected__title">
            {{ isPartner 
                ? ('Vous avez refuse la demande de partenariat de $name$.' | transloco: { name: invitation.account.organization_name})
            : ('Vous avez refuse la demande de collaboration de $name$.' | transloco: { name: invitation.account.organization_name})
         }}
        </div>
        <p class="invitation-rejected__subtitle margin-bottom-50">
            {{'$name$ sera informe par e-mail de votre decision.' | transloco: { name: invitation.account.organization_name} }}
        </p>
        <div class="invitation-rejected__buttons">
            <div class="dashboard-link">
                <a [href]="managerLink"
                   mat-flat-button
                   color="primary">
                    <span>{{ 'Aller au manager' | transloco }}</span>
                </a>
            </div>
        </div>
    </div>
</div>
